import type { GlobalConfig } from '@repo/go-ui';
import { Button } from '@repo/go-ui';
import type { i18n } from 'i18next';

import modalBox from '../../shared/components/ModalBox/modalBox';

export async function openDeleteAutoAnomaliesConfirmModal(configProvider: GlobalConfig, i18n: i18n): Promise<boolean> {
  try {
    const result = await modalBox({
      configProvider,
      modalBody: (close) => (
        <div style={{ width: 440 }}>
          <div style={{ marginBottom: 8, fontSize: 18, lineHeight: '24px', fontWeight: 600 }}>
            {i18n.t('alertsManagerWidget:autoAnomalies.deleteConfirm.title')}
          </div>
          <div style={{ marginBottom: 16, fontSize: 14, lineHeight: '20px' }}>
            {i18n.t('alertsManagerWidget:autoAnomalies.deleteConfirm.description')}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Button variant="primary" onClick={() => close('cancel')}>
              {i18n.t('alertsManagerWidget:autoAnomalies.deleteConfirm.cancel')}
            </Button>
            <Button variant="danger" onClick={() => close('ok')}>
              {i18n.t('alertsManagerWidget:autoAnomalies.deleteConfirm.confirm')}
            </Button>
          </div>
        </div>
      ),
    });

    return result === 'ok';
  } catch {
    return false;
  }
}
